export const NAME_PATTERN = /^[a-zA-ZÀÈÌÒÙàèìòù' ]*$/;
export const LETTERS_PATTERN = /^[a-zA-ZÀÈÌÒÙàèìòù]*$/;
export const NUMBERS_PATTERN = /^[0-9]*$/;
export const STREET_NUMBER_PATTERN = /^[a-zA-Z0-9/]*$/;
export const LETTERS_AND_NUMBERS_PATTERN = /^[a-zA-Z0-9]*$/;
export const MOBILE_PATTERN = /^(\((00|\+)39\)|(00|\+)39)?\d{9,10}$/;
export const ADDRESS_PATTERN = /^[a-zA-ZÀÈÌÒÙàèìòù' ]*$/;
export const DOCUMENT_TYPE_PATTERN = /^[a-zA-Z0-9ÀÈÌÒÙàèéìòù'\-\_ ]*$/;
export const IBAN_PATTERN = /^[A-Z]{2}[0-9]{2}[A-Za-z][0-9]{10}[0-9A-Za-z]{12}$/;
export const EMAIL_PATTERN = /^[\w-\.]+@([\w-]+\.)+[a-zA-Z]{2,4}$/;
export const TAX_ID_PATTERN = /^[A-Za-z]{6}[\dLMNP-Vlmnp-v]{2}[A-Za-z][\dLMNP-Vlmnp-v]{2}[A-MZamz][\dLMNP-Vlmnp-v]{3}[A-Za-z]/;
export const VAT_NUMBER_PATTERN = /^([a-zA-Z]{2})?[0-9]{11}$/;
export const ATECO_PATTERN = /^\d\d?(?:\.\d\d?)?(?:\.\d\d?)?$/;
export const ADDRESS_CITY_PROVINCE_PATTERN = /^[a-zA-ZÀÈÌÒÙàèìòù' -]*$/;
export const POSTAL_CODE_PATTERN = /^\d{5}$/;
export const LAND_REGISTRY_DATA_PATTERN = /^[0-9A-Za-z]{0,10}$/; // numbers, uppercase letters, lowercase letters, from 0 to 10 chars
